var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { PSP_SITE_NAME, HONDA_SITE_NAME, ACURA_SITE_NAME, PE_SITE_NAME } from '../../utils/constants';
import { getNavItems, getYears, getCorrespondingUrl } from './index';
var parseAutoFields = function (fieldsValue, pathname) {
    var _a, _b;
    var modelPageSettings = fieldsValue === null || fieldsValue === void 0 ? void 0 : fieldsValue.modelPageSettings;
    var categoryName = modelPageSettings === null || modelPageSettings === void 0 ? void 0 : modelPageSettings.model;
    var modelName = (_b = (_a = categoryName === null || categoryName === void 0 ? void 0 : categoryName.fields) === null || _a === void 0 ? void 0 : _a.name) === null || _b === void 0 ? void 0 : _b.toLowerCase();
    var modelNav = (fieldsValue === null || fieldsValue === void 0 ? void 0 : fieldsValue.modelNav) || [];
    var navItems = getNavItems(modelNav);
    return {
        modelPageSettings: modelPageSettings,
        categoryName: categoryName,
        modelName: modelName,
        gtmModelName: modelName,
        navItems: getNavItems(modelNav),
        dropdownOptions: getYears(fieldsValue, categoryName.fields.modelYears, navItems, pathname),
    };
};
var parseSitecoreFields = function (fieldsValue, pathname) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    if (!fieldsValue)
        return null;
    switch (fieldsValue.appName) {
        case HONDA_SITE_NAME:
        case ACURA_SITE_NAME:
            return parseAutoFields(fieldsValue, pathname);
        case PSP_SITE_NAME: {
            var modelPageSettings = fieldsValue === null || fieldsValue === void 0 ? void 0 : fieldsValue.modelPageSettings;
            return {
                modelPageSettings: modelPageSettings,
                categoryName: modelPageSettings.modelCategory,
                modelName: (_c = (_b = (_a = modelPageSettings.modelCategory) === null || _a === void 0 ? void 0 : _a.fields) === null || _b === void 0 ? void 0 : _b.categoryName) === null || _c === void 0 ? void 0 : _c.value,
                gtmModelName: '',
                modelNav: (fieldsValue === null || fieldsValue === void 0 ? void 0 : fieldsValue.modelNav) || [],
                navItems: getNavItems(fieldsValue === null || fieldsValue === void 0 ? void 0 : fieldsValue.modelNav),
                dropdownOptions: getYears(fieldsValue, modelPageSettings.modelCategory.fields.modelYears, getNavItems(fieldsValue === null || fieldsValue === void 0 ? void 0 : fieldsValue.modelNav), pathname),
            };
        }
        case PE_SITE_NAME: {
            var modelPageSettings = fieldsValue === null || fieldsValue === void 0 ? void 0 : fieldsValue.modelPageSettings;
            var overviewPageName_1 = fieldsValue === null || fieldsValue === void 0 ? void 0 : fieldsValue.overviewPageName;
            var categoryName = modelPageSettings.modelCategory;
            var modelName = (_e = (_d = categoryName === null || categoryName === void 0 ? void 0 : categoryName.fields) === null || _d === void 0 ? void 0 : _d.categoryName) === null || _e === void 0 ? void 0 : _e.value;
            var gtmModelName = modelName;
            var subCategories = (_g = (_f = modelPageSettings.modelCategory) === null || _f === void 0 ? void 0 : _f.fields) === null || _g === void 0 ? void 0 : _g.subCategories;
            var navItems_1 = ((_k = (_j = (_h = subCategories === null || subCategories === void 0 ? void 0 : subCategories.find(function (subCategory) { var _a, _b; return ((_b = (_a = subCategory === null || subCategory === void 0 ? void 0 : subCategory.modelNav) === null || _a === void 0 ? void 0 : _a.overviewPage) === null || _b === void 0 ? void 0 : _b.name.toLowerCase()) === overviewPageName_1.toLowerCase(); })) === null || _h === void 0 ? void 0 : _h.modelNav) === null || _j === void 0 ? void 0 : _j.overviewPage) === null || _k === void 0 ? void 0 : _k.subPages) || [];
            var dropdownOptions = (_o = (_m = (_l = modelPageSettings.modelCategory) === null || _l === void 0 ? void 0 : _l.fields) === null || _m === void 0 ? void 0 : _m.subCategories) === null || _o === void 0 ? void 0 : _o.map(function (subCategory) {
                var _a;
                return (__assign(__assign({}, subCategory), { correspondingUrl: getCorrespondingUrl(subCategory.modelNav.overviewPage, navItems_1, pathname), url: (_a = subCategory.modelNav.overviewPage) === null || _a === void 0 ? void 0 : _a.url }));
            });
            return {
                categoryName: categoryName,
                modelName: modelName,
                gtmModelName: gtmModelName,
                navItems: navItems_1,
                dropdownOptions: dropdownOptions,
                modelPageSettings: modelPageSettings,
            };
        }
        default:
            // Marine and Engine
            return parseAutoFields(fieldsValue, pathname);
    }
};
export default parseSitecoreFields;
